var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3152_170)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3152_170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "url(#pattern0_3152_170)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3152_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "#172B4D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3152_170",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3152_170",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3152_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3152_170",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmission);
export default __webpack_public_path__ + "static/media/admission.13d7c8cd9d179623a9de768be601d209.svg";
export { ForwardRef as ReactComponent };